/* eslint-disable no-console */
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { logout } from '../service';

export const useLogout = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const handleLogout = (overrideLogoutUrl: string | null = null) => {
        logout()
            .then((res) => {
                if (res.success === true) {
                    void queryClient.invalidateQueries({
                        queryKey: [],
                    });

                    if (overrideLogoutUrl !== null) {
                        navigate(`/auth/logout?logout_url=${encodeURIComponent(overrideLogoutUrl)}`, {
                            replace: true,
                        });
                        return;
                    }

                    navigate(`/auth/logout?logout_url=${res.data.logoutUrl}`, {
                        replace: true,
                    });
                }
            })
            .catch((err) => {
                console.error('Failed to logout', err);
                navigate('/auth/error?message=Failed to logout', {
                    replace: true,
                });
            });
    };

    return { handleLogout };
};
